import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import {token} from '@/utils/config'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // config.headers['Authorization'] =getToken()
    config.headers['Authorization'] ='Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImJkNjBhMjVkLTM4ZWItNGE0ZC1iNjA0LTJjZWY4ODFmMTI3OSJ9.IdVfelFn_Q2gnnTiPnZnuX9czz6FQtFNUeui4p4SL3qFTe7KKJy2Lt1QtVk71qe7lJVpZzDYMT4nKnZTb7gz7Q'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {

     

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 401) {
      //  store.dispatch('user/resetToken').then(() => {
      //    location.reload()
      //  })
      //  router.push('/login')
      return 
      }
       Message({
         message: res.message || 'Error',
         type: 'error',
         duration: 5 * 1000
       })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
